export function matchesFilterQuery(text: string | undefined, query: string): boolean {
    if (!query) {
        return true;
    }
    return (text ?? '').toLowerCase().includes(query.toLowerCase());
}

/** True when the query is empty or matches any of the given texts. */
export function matchesAnyText(query: string, ...texts: Array<string | undefined>): boolean {
    if (!query) {
        return true;
    }
    return texts.some((text) => matchesFilterQuery(text, query));
}

/**
 * Mirrors `items-search-query-controller.js#decodeItemQuery`:
 * `decodeURIComponent(query).replace(/:/g, ' = ')`.
 */
export function decodeItemQuery(query: string): string {
    try {
        return decodeURIComponent(query).replace(/:/g, ' = ');
    } catch {
        return query.replace(/:/g, ' = ');
    }
}
